import {HTMLProps} from 'react';

interface IProps extends Omit<HTMLProps<HTMLDivElement>, 'ref'> {
  disabled?: boolean;
  hasMdWidth?: boolean;
}

export default function MaxWidth({
  className,
  disabled,
  hasMdWidth,
  ...rest
}: IProps) {
  return (
    <div
      className={cn(
        className,
        'mx-auto my-0',
        !disabled && 'w-full lg:w-default-max-width',
        !disabled && hasMdWidth && 'md:w-[490px]'
      )}
      {...rest}
    />
  );
}
